import { Body, Box, Caption, H1, H2, H3, H4, H5, H6, black } from 'dma-ui-kit';
import styled from 'styled-components';
import { colorMap } from 'helpers/colormap';

const Container = styled(Box)`
  margin-bottom: 30px;
  max-width: 1250px;
  padding: 0 12px;

  &:nth-child(1) {
    & h1 {
      margin-bottom: -15px;
    }
    & h2 {
      margin-bottom: -15px;
    }
    & h3 {
      margin-bottom: -10px;
    }
    & h4 {
      margin-bottom: -5px;
    }
    & h5 {
      margin-bottom: -5px;
    }
    & h6 {
      margin-bottom: -5px;
    }
  } 


  @media (min-width: 768px) {
    padding: 0 24px;

    &:nth-child(1) {
      & h1 {
        margin-bottom: -20px;
      }
      & h2 {
        margin-bottom: -16px;
      }
      & h3 {
        margin-bottom: -10px;
      }
      & h4 {
        margin-bottom: -8px;
      }
      & h5 {
        margin-bottom: -6px;
      }
      & h6 {
        margin-bottom: -4px;
      }
    } 

  }

  @media (min-width: 1024px) {
    padding: 0 48px;

    &:nth-child(1) {
      & h1 {
        margin-bottom: -25px;
      }
      & h2 {
        margin-bottom: -20px;
      }
      & h3 {
        margin-bottom: -10px;
      }
      & h4 {
        margin-bottom: -10px;
      }
      & h5 {
        margin-bottom: -10px;
      }
      & h6 {
        margin-bottom: -10px;
      }
    } 
      
  }    

`;

const TwoLineHeader = props => {
    const { attributes, relationships } = props.paragraph;
    const { field_line1_caption_text, field_line2_caption_text } = attributes;

    const field_font_color = (relationships.field_font_color?.data?.attributes?.name) ? relationships.field_font_color.data.attributes.name : 'black';

    const field_line1_size = (relationships.field_line1_size?.data?.attributes?.name) ? relationships.field_line1_size.data.attributes.name : 'Body';
    const field_line2_size = (relationships.field_line2_size?.data?.attributes?.name) ? relationships.field_line2_size.data.attributes.name : 'Body';

    // Maps Taxonomy to Typography class
    const color = (colorMap[field_font_color]) ? colorMap[field_font_color] : black;

    const sizes = { 'Body': Body, 'Caption': Caption, 'H1': H1, 'H2': H2, 'H3': H3, 'H4': H4, 'H5': H5, 'H6': H6 };

    const Line1DisplaySize = (sizes[field_line1_size]) ? sizes[field_line1_size] : Body;
    const Line2DisplaySize = (sizes[field_line2_size]) ? sizes[field_line2_size] : Body;

    return (
        <>
            <Container>
                <Line1DisplaySize color={color}>{field_line1_caption_text}</Line1DisplaySize>
                <Line2DisplaySize color={color}>{field_line2_caption_text}</Line2DisplaySize>
            </Container>
        </>
    );
};

export default TwoLineHeader;
